<template>
  <div class="market-giftCouponRecord-index">
    <el-tabs v-model="tabsKey" type="card" :closable="false" :before-leave="onTabClick" >
      <el-tab-pane label="banner列表">
        <div class="tab-content">
          <BannerTop></BannerTop>
        </div>
      </el-tab-pane>
      <el-tab-pane label="弹窗列表">
        <div class="tab-content">
          <BannerPop></BannerPop>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import BannerTop from './bannerTop'
import BannerPop from './bannerPop'
export default {
  name: "",
  components: {
    BannerTop,
    BannerPop
  },
  data() {
    return {
      tabsKey: 0
    };
  },
  created () {
    if(this.$route.query.tabsKey){
      this.tabsKey = this.$route.query.tabsKey
    }
  },
  methods: {
    onTabClick() {

    }
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-giftCouponRecord-index {
  width: 100%;
  padding: 35px 20px;
  box-sizing: border-box;

  .tab-content {
    margin-top: -30px;
  }
}
</style>
